export default "__VITE_ASSET__CMGNE2oA__"